import {getMethod, postMethod} from '~/api'
async function post(request) {
    return await postMethod('/proxy/paymentsPageSelection', request)
}
async function get(request) {
    return await getMethod('/proxy/paymentsPageSelection', request)
}

export {post, get}
